import { API } from "./utils";

export const getFeatures = () => {
  return API.get("/features");
};

export const updateFeatures = (features) => {
  return API.put("/features", features);
};
